import { getApiUrl } from "./tcApiUrl";
export function getExportComplianceURL() {
  const classifyurl = `${getApiUrl("exportCompliance")}`;
  return classifyurl;
}

export const getExportComplianceURLValue = () => {
  return getExportComplianceURL();
};
